"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@trs/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelectNew = _interopRequireWildcard(require("react-select-new"));
var _Select = _interopRequireDefault(require("./Select.style"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _components = require("./components");
var _helpers = require("./helpers");
var _excluded = ["ariaLabel", "value", "onChange", "id", "error", "options", "className", "components", "placeholder", "isSimpleValue", "disabled", "width", "labelKey", "valueKey", "filters", "isMulti", "isClearable"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SelectV2 = function SelectV2(_ref) {
  var ariaLabel = _ref.ariaLabel,
    value = _ref.value,
    _onChange = _ref.onChange,
    id = _ref.id,
    error = _ref.error,
    options = _ref.options,
    className = _ref.className,
    components = _ref.components,
    placeholder = _ref.placeholder,
    isSimpleValue = _ref.isSimpleValue,
    disabled = _ref.disabled,
    width = _ref.width,
    labelKey = _ref.labelKey,
    valueKey = _ref.valueKey,
    filters = _ref.filters,
    isMulti = _ref.isMulti,
    isClearable = _ref.isClearable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    className: "select-wrapper",
    width: width,
    hasError: !(0, _utils.isBlank)(error)
  }, /*#__PURE__*/_react["default"].createElement(_reactSelectNew["default"], _extends({
    classNamePrefix: "select-component",
    autoComplete: "off",
    value: (0, _helpers.getValue)(value, isSimpleValue, options),
    onChange: function onChange(e) {
      _onChange(e);
    },
    placeholder: placeholder,
    "aria-label": ariaLabel || placeholder,
    id: id,
    className: className,
    options: options,
    isMulti: isMulti,
    isClearable: isClearable,
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      Option: _components.Option,
      SingleValue: _components.SelectedItem,
      MultiValueLabel: _components.MultiValueLabel,
      MultiValueRemove: _components.MultiValueRemove
    }, components),
    isDisabled: disabled,
    filterOption: (0, _reactSelectNew.createFilter)(filters)
  }, (0, _helpers.getOptionsDataProps)(labelKey, valueKey), otherProps)), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: error,
    id: "".concat(id, "Error")
  }));
};
SelectV2.defaultProps = {
  value: null,
  ariaLabel: null,
  id: 'react-select-id',
  className: 'react-select-element',
  error: null,
  options: [],
  components: {},
  placeholder: '',
  isSimpleValue: false,
  disabled: false,
  width: '',
  labelKey: '',
  valueKey: '',
  filters: null,
  isMulti: false,
  isClearable: false
};
SelectV2.propTypes = {
  components: _propTypes["default"].shape({}),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  error: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].array]),
  ariaLabel: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string,
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  isSimpleValue: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  width: _propTypes["default"].string,
  labelKey: _propTypes["default"].string,
  valueKey: _propTypes["default"].string,
  filters: _propTypes["default"].shape({}),
  isMulti: _propTypes["default"].bool,
  isClearable: _propTypes["default"].bool
};
SelectV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SelectV2",
  "props": {
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }, {
          "name": "bool"
        }, {
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "'react-select-id'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'react-select-element'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false
    },
    "components": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isSimpleValue": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "labelKey": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "valueKey": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "filters": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "isMulti": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isClearable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(SelectV2);
exports["default"] = _default;